module.exports = __webpack_public_path__ + "static/media/27-6.0960b363.mp3";